import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import SupportServicesTable from "../SupportServicesTable";

const SupportServices = forwardRef(
  ({ data, selectedSpecies, isEditing, submit }, ref) => {
    return (
      <div className="sac-border mb-4">
        <div className="flex">
          <div>
            <span className="circle bg-dashboard-blue mr-4">5</span>
          </div>

          <div className="w-full">
            <h2 className="text-2xl mt-1">Support Services</h2>
            {data.map(({ id, attributes, attributes: { species } }) => {
              if (species === selectedSpecies || !selectedSpecies) {
                return (
                  <SupportServicesTable
                    key={id}
                    id={id}
                    attributes={attributes}
                    species={attributes.species}
                    isEditing={isEditing}
                    submit={submit}
                    ref={ref}
                  />
                );
              }
            })}
          </div>
        </div>
      </div>
    );
  }
);

SupportServices.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isEditing: PropTypes.bool.isRequired,
  selectedSpecies: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired,
};

export default SupportServices;
